import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { Metric } from "./metricsColumns";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { errorToast } from "@/lib/utils/ToastUtils";
import { toast } from "sonner";
import { TbTargetArrow } from "react-icons/tb";
import { cn } from "@/lib/utils/ui";
import { trpc } from "@/lib/trpc/client";
import { patchKeyedListCache, replaceInList } from "@trainrr/api-client";

interface MetricGoalDialogProps {
  clientId: string;
  metric: Metric;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contentClassName?: string;
}

const MetricDailyTargetDialog: React.FC<MetricGoalDialogProps> = ({
  open,
  onOpenChange,
  metric,
  clientId,
  contentClassName,
}) => {
  const [dailyTarget, setdailyTarget] = useState<string>();
  const utils = trpc.useUtils();
  const listInput = { clientId };

  const setDailyTarget = trpc.metrics.setDailyTarget.useMutation({
    onSuccess: (saved) => {
      patchKeyedListCache(utils.metrics.listForClient, listInput, (old) =>
        replaceInList(old, saved),
      );
      toast.success(
        `Daily target for ${metric.name} updated to ${saved.daily_target ?? dailyTarget}`,
      );
      onOpenChange(false);
    },
    onError: (error) => {
      errorToast(
        error,
        "There was an error updating the daily target for this metric",
      );
    },
  });

  useEffect(() => {
    setdailyTarget(String(metric.daily_target ?? ""));
  }, [metric]);

  const handleUpdate = () => {
    const trimmed = dailyTarget?.trim() ?? "";
    const parsed = trimmed === "" ? null : Number(trimmed);
    if (parsed !== null && !Number.isFinite(parsed)) {
      toast.error("Enter a valid daily target");
      return;
    }

    setDailyTarget.mutate({
      clientId,
      metricId: metric.id,
      dailyTarget: parsed,
    });
  };

  return (
    <>
      <div>
        <Dialog
          open={open}
          onOpenChange={onOpenChange}
          analyticsName="metric_daily_target_dialog"
        >
          <DialogContent
            className={cn(
              "max-w-[800px] max-h-full overflow-y-auto",
              contentClassName,
            )}
          >
            <DialogTitle>{metric.name} Daily Target</DialogTitle>
            <div className="flex  flex-col p-4 gap-4">
              <Input
                type="number"
                placeholder={`Daily target for ${metric.name}`}
                className="border rounded p-2"
                value={dailyTarget}
                onChange={(e) => {
                  setdailyTarget(e.target.value);
                }}
              />
              <Button
                onClick={handleUpdate}
                disabled={setDailyTarget.isPending}
              >
                <TbTargetArrow className="w-4 h-4 mr-2 " /> Update Daily Target
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default MetricDailyTargetDialog;
